module.exports = __webpack_public_path__ + "static/media/icheck-orange.1aeb9bfc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icheck-orange.png
 ** module id = 1616
 ** module chunks = 0
 **/